export const SELECT_BUTTON_SIZES = {
  SM: 'sm',
  MD: 'md',
};

export const SELECT_BUTTON_TYPES = {
  SINGLE: 'single',
  MULTI: 'multi',
};
